import React from 'react'
import { connect } from 'react-redux';
import Wix from 'Wix';
import { ButtonContainer } from '../style'
import { convertMobileUmitableFields, getDiffToMobileConvert } from '../../../../../editSlide/api/converter';
import { getBackgroundGradient, getValueAccordingToLanguage } from '../../../../../Utils/utils';
import { ButtonIcon } from '../../../../../Utils/elements';
import { getRightPropertyValue } from '../../../../../Utils/helpers';
import { ButtonContentContainer } from '../../../../../editSlide/modules/MainView/Workspace/Captions/style';


class ButtonCaption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            buttonStyle: {
                hoverAnimationType: null,

                backgroundColor: null,
                padding: null,

                borderRadius: null,
                borderWidth: null,
                borderColor: null,

                fontFamily: null,
                textColor: null,
                fontStyle: null,
                fontWeight: null,
                textShadow: null,

                textColorHover: null,
                backgroundColorHover: null,
                borderColorHover: null,

                position: {
                    x: null,
                    y: null,
                },
            },
            captionText: this.props.caption.text
        }
    }

    componentWillMount() {
        const { buttonStyle, captionText } = this.getStyle(this.props.caption)
        this.setState({
            buttonStyle,
            captionText
        })
    }

    getStyle(caption) {
        const lang = this.props.lang
        const locale = this.props.locale
        const deviceType = Wix.Utils.getDeviceType()

        const isMobile = deviceType === 'mobile'
        const desktopDims = this.props.slide === undefined ? { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight } : { width: this.props.slide.editedWidth, height: this.props.slide.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (deviceType === 'mobile') {
            const { mobileDiffW, mobileDiffH } = getDiffToMobileConvert(
                this.props.widgetDimensions.width,
                this.props.widgetDimensions.height,
                this.props.widgetDimensions.mobileWidth,
                this.props.widgetDimensions.mobileHeight,
            )
            const maxDiff = mobileDiffW > mobileDiffH ? mobileDiffW : mobileDiffH
            caption = convertMobileUmitableFields(_.cloneDeep(caption), mobileDiffW, mobileDiffH, maxDiff)
        }


        let borderRadiusProperty, borderWidthProperty, fontSizeProperty, lineHeightProperty,
            paddingProperty, widthProperty, positionProperty, heightProperty, letterSpacingProperty;

        switch (deviceType) {
            case 'desktop':
                borderRadiusProperty = 'borderRadius';
                borderWidthProperty = 'borderWidth';
                fontSizeProperty = 'fontSize';
                lineHeightProperty = 'lineHeight';
                paddingProperty = 'padding';
                widthProperty = 'width';
                heightProperty = 'height';
                positionProperty = 'position';
                letterSpacingProperty = 'letterSpacing';
                break;

            case 'mobile':
                borderRadiusProperty = 'mobileBorderRadius';
                borderWidthProperty = 'mobileBorderWidth';
                fontSizeProperty = 'mobileFontSize';
                lineHeightProperty = 'mobileLineHeight';
                paddingProperty = 'mobilePadding';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                positionProperty = 'mobilePosition';
                letterSpacingProperty = 'mobileLetterSpacing';
                break;
        }

        const captionText = caption.text;
        // const captionText = getValueAccordingToLanguage(caption, 'text', lang, locale)
        const fontFamily = caption.fontFamily;
        // const fontFamily = getValueAccordingToLanguage(caption, 'fontFamily', lang, locale)
        // const rtl = getValueAccordingToLanguage(caption, 'isRTL', lang, locale)
        const rtl = caption.isRtl;
        const isRTL = rtl === undefined ? (fontFamily ? fontFamily.rtl : false) : rtl
        // const isRTL = caption.fontFamily && (caption.fontFamily.custom ? caption.isRTL : caption.fontFamily.rtl)
        // const isRTL = caption.isRTL === undefined ? (caption.fontFamily ? caption.fontFamily.rtl : false) : caption.isRTL
        const diffBetwenFontSizeAndLineHeight = (1.2 * caption[fontSizeProperty]) - (caption[lineHeightProperty] / 100 * caption[fontSizeProperty]);

        const needMobileConvert = caption.needMobileConvert || false

        let captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, caption, 1, '', true, needMobileConvert)
        if (caption.boxId !== '' && isMobile && caption.mobilePosition && caption.mobilePosition.relativeX == undefined) {
            const clonedCaption = _.cloneDeep(caption)
            delete clonedCaption.mobilePosition
            const convertedPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, clonedCaption, 1, '', true, needMobileConvert)
            captionPosition = {
                ...captionPosition,
                relativeX: convertedPosition.relativeX,
                relativeY: convertedPosition.relativeY
            }
        }
        const xProp = caption.boxId === '' ? 'x' : 'relativeX'
        const yProp = caption.boxId === '' ? 'y' : 'relativeY'
        // let captionStyle = {
        //     hoverAnimationType: caption.animation.class,

        //     backgroundColor: typeof caption.backgroundColor == 'object' ? getBackgroundGradient({ backgroundColor: caption.backgroundColor }) : caption.backgroundColor,
        //     padding: caption[paddingProperty],

        //     borderRadius: caption[borderRadiusProperty],
        //     borderWidth: caption[borderWidthProperty],
        //     borderColor: caption.borderColor,

        //     fontFamily: (fontFamily && fontFamily.value != undefined) ? fontFamily.value : 'Helvetica',
        //     // fontFamily: (caption.fontFamily && caption.fontFamily.value != undefined) ? caption.fontFamily.value : 'Helvetica',
        //     fontStyle: (caption.style && caption.style.italic) ? 'italic' : '',
        //     fontSize: caption[fontSizeProperty],
        //     lineHeight: caption[lineHeightProperty],
        //     fontWeight: (fontFamily && fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
        //     // fontWeight: (caption.fontFamily && caption.fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
        //     underline: (caption.style && caption.style.underline) ? 'underline' : caption.style && caption.style.strikethrough ? 'line-through' : 'none',
        //     textAlign: caption.style.textAlign,
        //     letterSpacing: caption[letterSpacingProperty],
        //     textTransform: caption.letterCase || 'none',
        //     textColor: caption.fontColor,
        //     shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.size}px ${caption.shadow.color}`,
        //     textShadow: !caption.textHasShadow ? '' : `${caption.textShadow.x}px ${caption.textShadow.y}px ${caption.textShadow.blur}px ${caption.textShadow.color}`,
        //     textColorHover: caption.isHover ? caption.fontColorHover : '',
        //     backgroundColorHover: caption.isHover ? caption.backgroundColorHover : '',
        //     borderColorHover: caption.isHover ? caption.borderColorHover : '',
        //     // direction: (caption.fontFamily && caption.fontFamily.rtl) ? 'rtl' : '',
        //     direction: isRTL ? 'rtl' : '',
        //     textStroke: `${caption.textStroke ? caption.textStroke.size : 0}px ${caption.textStroke ? caption.textStroke.color : 'rgba(255, 0, 0, .5)'}`,

        //     position: {
        //         x: caption.boxId === '' ? caption[positionProperty].x : caption[positionProperty].relativeX,
        //         y: caption.boxId === '' ? caption[positionProperty].y : caption[positionProperty].relativeY
        //     },
        //     width: caption[widthProperty],
        //     zIndex: caption.layer + 200,
        //     diffBetwenFontSizeAndLineHeight: diffBetwenFontSizeAndLineHeight > 0 ? diffBetwenFontSizeAndLineHeight / 2 : 0,
        //     cursor: this.props.caption.linkTo ? 'pointer' : ''
        // }

        let captionStyle = {
            hoverAnimationType: caption.animation.class,

            backgroundColor: typeof caption.backgroundColor == 'object' ? getBackgroundGradient({ backgroundColor: caption.backgroundColor }) : caption.backgroundColor,
            padding: getRightPropertyValue(desktopDims, mobileDims, 'padding', isMobile, caption, 1, '', true, needMobileConvert),

            borderRadius: getRightPropertyValue(desktopDims, mobileDims, 'borderRadius', isMobile, caption, 1, '', true, needMobileConvert),
            borderWidth: getRightPropertyValue(desktopDims, mobileDims, 'borderWidth', isMobile, caption, 1, '', true, needMobileConvert),
            borderColor: caption.borderColor,

            fontFamily: (fontFamily && fontFamily.value != undefined) ? fontFamily.value : 'Helvetica',
            // fontFamily: (caption.fontFamily && caption.fontFamily.value != undefined) ? caption.fontFamily.value : 'Helvetica',
            fontStyle: (caption.style && caption.style.italic) ? 'italic' : '',
            fontSize: getRightPropertyValue(desktopDims, mobileDims, 'fontSize', isMobile, caption, 1, '', true, needMobileConvert),
            lineHeight: getRightPropertyValue(desktopDims, mobileDims, 'lineHeight', isMobile, caption, 1, '', true, needMobileConvert),
            fontWeight: (fontFamily && fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
            // fontWeight: (caption.fontFamily && caption.fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
            underline: (caption.style && caption.style.underline) ? 'underline' : caption.style && caption.style.strikethrough ? 'line-through' : 'none',
            textAlign: caption.style.textAlign,
            letterSpacing: getRightPropertyValue(desktopDims, mobileDims, 'letterSpacing', isMobile, caption, 1, '', true, needMobileConvert),
            textTransform: caption.letterCase || 'none',
            textColor: caption.fontColor,
            shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.size}px ${caption.shadow.color}`,
            textShadow: !caption.textHasShadow ? '' : `${caption.textShadow.x}px ${caption.textShadow.y}px ${caption.textShadow.blur}px ${caption.textShadow.color}`,
            textColorHover: caption.isHover ? caption.fontColorHover : '',
            backgroundColorHover: caption.isHover ? caption.backgroundColorHover : '',
            borderColorHover: caption.isHover ? caption.borderColorHover : '',
            // direction: (caption.fontFamily && caption.fontFamily.rtl) ? 'rtl' : '',
            direction: isRTL ? 'rtl' : '',
            textStroke: `${caption.textStroke ? getRightPropertyValue(desktopDims, mobileDims, 'size', isMobile, caption.textStroke, 1, '', false, needMobileConvert) : 0}px ${caption.textStroke ? caption.textStroke.color : 'rgba(255, 0, 0, .5)'}`,

            position: {
                x: captionPosition[xProp],
                y: captionPosition[yProp]
            },
            width: getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, caption, 1, '', true, needMobileConvert),
            zIndex: caption.layer + 200,
            diffBetwenFontSizeAndLineHeight: diffBetwenFontSizeAndLineHeight > 0 ? diffBetwenFontSizeAndLineHeight / 2 : 0,
            cursor: this.props.caption.linkTo ? 'pointer' : ''
        }
        const buttonAnimationOn = caption.buttonAnimationOn || caption.buttonAnimationOn === undefined
        if (caption.isHover && caption.animation && buttonAnimationOn && (caption.animation.value === "shutter-in-vertical" || caption.animation.value === "shutter-in-horizontal")) {
            // captionStyle.backgroundColorHover = typeof caption.backgroundColor == 'object' ? getBackgroundGradient({backgroundColor: caption.backgroundColor}) : convertedStyle.backgroundColor
            // captionStyle.backgroundColor = caption.backgroundColorHover
            captionStyle.textColorHover = caption.fontColor
            captionStyle.textColor = caption.fontColorHover
        }

        return { buttonStyle: captionStyle, captionText }
    }

    goToLink() {
        if (this.props.caption.onClick && this.props.caption.onClick.value === 'doNothing') return
        // сначала проверяем, есть ли ссылка из новых настроек
        if (this.props.caption.linkTo) {
            Wix.navigateTo(this.props.caption.linkTo, () => { })
        }
        // если нет новой, то используем старую
        else if (this.props.caption.onClick.value === 'navigateTo') {
            switch (this.props.caption.linkType.value) {
                case 'link':
                    window.open(this.props.caption.link, '_blank');
                    break;
                case 'wix':
                    Wix.navigateTo({
                        'type': 'PageLink',
                        'pageId': this.props.caption.link.value
                    }, () => { });
                    break;
                case 'anchor':
                    Wix.navigateToAnchor(this.props.caption.link.value, function (error) { console.log(error.error) });
                    break;
            }
        }
    }

    render() {
        const unicalClassName = this.props.unicalClassName ? `caption-${this.props.slideIndex}-${this.props.captionIndex}-${this.props.unicalClassName} ` : ''
        const buttonClassNames = [
            `caption-container-${this.props.slideIndex}-${this.props.captionIndex}`,
            `animate-${this.props.slideIndex}-${this.props.captionIndex}`,
            `caption-${this.props.slideIndex}-${this.props.captionIndex}`,
            'animated',
            unicalClassName
        ]
        const deviceType = Wix.Utils.getDeviceType()
        const desktopDims = { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        const isMobile = deviceType === 'mobile'
        const caption = _.cloneDeep(this.props.caption)
        caption.text = this.state.captionText
        const buttonAnimationOn = caption.buttonAnimationOn || caption.buttonAnimationOn === undefined

        const buttonStyles = {
            top: `${this.state.buttonStyle.position.y}px`,
            left: `${this.state.buttonStyle.position.x}px`,
            width: `${Math.ceil(this.state.buttonStyle.width)}px`,
            zIndex: this.state.buttonStyle.zIndex
        }
        const buttonParagraphStyles = {
            background: this.state.buttonStyle.backgroundColor,
            borderColor: this.state.buttonStyle.borderColor,
            borderRadius: Math.floor(this.state.buttonStyle.borderRadius) + 'px',
            borderWidth: Math.round(this.state.buttonStyle.borderWidth) + 'px',
            borderStyle: 'solid',
            fontSize: `${Math.floor(this.state.buttonStyle.fontSize) + 'px'}`,
            fontFamily: this.state.buttonStyle.fontFamily,
            fontStyle: this.state.buttonStyle.fontStyle,
            fontWeight: `${this.state.buttonStyle.fontWeight}`,
            color: this.state.buttonStyle.hoverAnimationType === 'transform' ? this.state.buttonStyle.textColor : 'f',
            // textShadow: this.state.buttonStyle.hoverAnimationType === 'transform' ? this.state.buttonStyle.textShadow : 'none',
            textShadow: this.state.buttonStyle.textShadow,
            boxShadow: this.state.buttonStyle.shadow,
            lineHeight: `${this.state.buttonStyle.lineHeight / 100 * this.state.buttonStyle.fontSize}px`,
            textAlign: this.state.buttonStyle.textAlign,
            textTransform: this.state.buttonStyle.textTransform,
            letterSpacing: `${this.state.buttonStyle.letterSpacing / 100}em`,
            /* для убирания полос по краям при анимации ховера округляем паддинги*/
            padding: `${Math.round(this.state.buttonStyle.padding + this.state.buttonStyle.diffBetwenFontSizeAndLineHeight)}px ${Math.round(this.state.buttonStyle.padding)}px`,
            cursor: this.state.buttonStyle.cursor,
            direction: `${this.state.buttonStyle.direction}`,
        }

        const buttonTextStyles = {
            borderWidth: Math.round(this.state.buttonStyle.borderWidth) + 'px',
            fontSize: `${Math.floor(this.state.buttonStyle.fontSize) + 'px'}`,
            fontFamily: this.state.buttonStyle.fontFamily,
            fontStyle: this.state.buttonStyle.fontStyle,
            fontWeight: `${this.state.buttonStyle.fontWeight}`,
            color: this.state.buttonStyle.textColor,
            textShadow: this.state.buttonStyle.textShadow,
            lineHeight: `${this.state.buttonStyle.lineHeight / 100 * this.state.buttonStyle.fontSize}px`,
            textDecoration: this.state.buttonStyle.underline,
            textAlign: this.state.buttonStyle.textAlign,
            textTransform: this.state.buttonStyle.textTransform,
            letterSpacing: `${this.state.buttonStyle.letterSpacing / 100}em`,
            padding: `${Math.round(this.state.buttonStyle.padding + this.state.buttonStyle.diffBetwenFontSizeAndLineHeight)}px ${Math.round(this.state.buttonStyle.padding)}px`,
            direction: `${this.state.buttonStyle.direction}`,
            WebkitTextStroke: this.state.buttonStyle.textStroke,
        }

        if (buttonParagraphStyles.textTransform === 'capitalize') {
            const re = /(?:^|\s|[-"()[\]{}.?;!@#$%^&*+=|<>`~,\\/])+\S/g;
            buttonParagraphStyles.textTransform = 'none'
            buttonTextStyles.textTransform = 'none'
            caption.text = caption.text.toLowerCase().replace(re, c => c.toUpperCase())
        }
        const iconOn = caption.iconOn
        const iconSettingsRight = iconOn ? {
            size: getRightPropertyValue(desktopDims, mobileDims, 'size', isMobile, caption.iconSettings),
            margin: getRightPropertyValue(desktopDims, mobileDims, 'margin', isMobile, caption.iconSettings),
            location: caption.iconSettings.location,
            icon: caption.iconSettings.icon,
            isCustom: caption.iconSettings.isCustom,
            animation: caption.buttonIconAnimationOn ? caption.iconSettings.animation : 'none',
        } : {
            location: 'left',
            size: 0,
            margin: 0,
            icon: ''
        }

        let iconAnimationClass = ''
        if (iconOn && iconSettingsRight.animation !== 'none') {
            iconAnimationClass = `hvr-icon-${iconSettingsRight.animation}`
        }
        return (
            <ButtonContainer {...this.state.buttonStyle}
                id={`caption-${caption.index}`}
                onClick={() => this.goToLink()}
                style={buttonStyles}
                className={buttonClassNames.join(' ')}
                isGradient={typeof caption.backgroundColor === 'object' && caption.backgroundColor.type == 'gradient'}
                // className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} animate-${this.props.slideIndex}-${this.props.captionIndex}`}
                // className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} animate-${this.props.slideIndex}-${this.props.captionIndex}`
                // + ` caption-${this.props.slideIndex}-${this.props.captionIndex} ${unicalClassName}`}
                data-animation-in={this.props.animationIn || 'null'}
                buttonAnimationOn={buttonAnimationOn}
            >
                {/* <div
                    className={`caption-${this.props.slideIndex}-${this.props.captionIndex} ${unicalClassName}`}
                    // style={{width: '100%', height: '100%'}}
                > */}
                <ButtonContentContainer
                    style={{...buttonParagraphStyles}}
                    className={`caption-content ${caption.isHover && buttonAnimationOn ? `hvr-${caption.animation.value}` : ''}  ${iconAnimationClass}`}
                    iconOn={iconOn}
                    iconLocation={iconSettingsRight.location}
                    textAlign={buttonParagraphStyles.textAlign}
                // className={`caption-${this.props.slideIndex}-${this.props.captionIndex} 
                // caption-content ${this.props.caption.isHover ? `hvr-${this.props.caption.animation.value}` : ''} ${unicalClassName}`}
                >
                    {
                        iconOn &&
                        <ButtonIcon
                            icon={iconSettingsRight.icon}
                            isCustom={iconSettingsRight.isCustom}
                            hasPadding={false}
                            size={iconSettingsRight.size}
                            margin={caption.captionText != '' ? iconSettingsRight.margin : 0}
                            location={iconSettingsRight.location}
                        />
                    }
                    <span style={{textDecoration: buttonTextStyles.textDecoration, textShadow: buttonTextStyles.textShadow, WebkitTextStroke: buttonTextStyles.WebkitTextStroke}}>
                        {caption.text}
                    </span>
                </ButtonContentContainer>
                {/* {caption.animation && caption.animation.class !== 'transform' &&
                        <div className={'button-text'} style={buttonTextStyles} >
                            {caption.text}
                        </div>
                    } */}
                {/* </div> */}
            </ButtonContainer>
        )
    }
}

// function mapStateToProps(state) {
//     return state;
// }

// export default connect(mapStateToProps)(ButtonCaption);
export default ButtonCaption;